import { render, staticRenderFns } from "./HotSearchList.vue?vue&type=template&id=547f492f&scoped=true&"
import script from "./HotSearchList.vue?vue&type=script&lang=js&"
export * from "./HotSearchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f492f",
  null
  
)

export default component.exports